var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
let AExpandableFilter = class AExpandableFilter extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #region @PropSyncs
        // #endregion
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isExpanded = true;
        // #endregion
        // #region Async methods (api calls only)
        // #endregion
        // #region Getters & Setters
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    onToggleFilters() {
        this.isExpanded = !this.isExpanded;
    }
};
AExpandableFilter = __decorate([
    Component({})
], AExpandableFilter);
export default AExpandableFilter;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
